import { Link } from 'react-router-dom';
import { categories } from '@/mocks/gossip';

export default function CategoryStrip() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-16">
        <div className="text-center">
          <span className="text-xs font-medium tracking-[0.25em] text-primary-600">CATEGORIES</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按你的兴趣找瓜</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600">
            六大内容方向持续更新，从明星动态到情感话题，挑一个你关心的领域，直接开始浏览。
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => (
            <Link
              key={category.slug}
              to={`/gossip?category=${category.slug}`}
              className="card-rise group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-2xl`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-heading text-base font-bold text-foreground-950">{category.name}</span>
                <span className="mt-1 block truncate text-xs text-foreground-500">{category.desc}</span>
              </span>
              <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-1"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}